import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.profile.info;
//VERIFY IF THE JWT IS SET
const getMemberProfilePicture = createSelector(
  getData,
  info =>
    info.imageURL
      ? info.imageURL
      : info.isFemale
        ? "https://firebasestorage.googleapis.com/v0/b/fir-amst-8de23.appspot.com/o/placeholder%2Ffemale.png?alt=media&token=9526c2bb-d143-4749-bc41-1bce7fc1f8c1"
        : "https://firebasestorage.googleapis.com/v0/b/fir-amst-8de23.appspot.com/o/placeholder%2Fmale.png?alt=media&token=f37028c3-cb83-4b39-88a7-9eb3d394bd1c"
);
export default getMemberProfilePicture;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberProfilePicture.js